import { PAST_WEEK_SEARCH_TYPE } from 'utils/constants';

export const defaultAuthenticationState = {
  isAuthenticated: false,
  account: '',
  accountId: '',
  endCustomerAccountId: '',
  varAccountId: '',
  ecomAccess: false,
  ecomCheckout: false,
  eCommerceAccess: [],
  userSFid: '',
  userType: '',
  userName: '',
};

export const defaultLoadingState = false;

export const defaultCurrentQuoteState = {
  quoteName: '',
  quoteTotal: '',
};

export const defaultBaseAccountState = {};

export const defaultCurrentAccountState = {};

export const defaultSearchState = {
  searchType: PAST_WEEK_SEARCH_TYPE,
  searchTerm: '',
  orderDateStart: null,
  orderDateEnd: null,
};

export const defaultNotificationState = {
  text: '',
  show: false,
  type: 'success',
  timeout: null,
};
